import { render, staticRenderFns } from "./FormErapaivanSiirto.vue?vue&type=template&id=45962cd6&scoped=true&"
import script from "./FormErapaivanSiirto.vue?vue&type=script&lang=js&"
export * from "./FormErapaivanSiirto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45962cd6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45962cd6')) {
      api.createRecord('45962cd6', component.options)
    } else {
      api.reload('45962cd6', component.options)
    }
    module.hot.accept("./FormErapaivanSiirto.vue?vue&type=template&id=45962cd6&scoped=true&", function () {
      api.rerender('45962cd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormErapaivanSiirto.vue"
export default component.exports